const emptyBox = {
  data: null,
  loading: false,
  error: null,
  pendingRequestId: null,
};

export const netSentimentScoreInitialState = {
  statistics: {
    index: { ...emptyBox },
    trend: { ...emptyBox },
  },
  resourceProfile: {
    index: { ...emptyBox },
    trend: { ...emptyBox },
  },
};
